export default __webpack_public_path__ + "static/z2-84a4948a5acafe7c1b5b53608820d613.svg";